<template>
  <div class="footer">
    <p>
      ©2022-2026 QuickMatrixTool |
      <a
        href="https://beian.miit.gov.cn/"
        target="_blank"
        rel="noopener noreferrer"
      >鄂ICP备2025098093号</a>
    </p>
  </div>
</template>

<style scoped>
.footer {
  bottom: 0;
  width: 100%;
  text-align: center;
  background: #f1f1f1;
  padding: 0;
  height: 53px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer p {
  margin: 0;
  font-size: 14px;
  color: #444;
  padding: 0 12px;
}

.footer a {
  color: #444;
  text-decoration: none;
}

.footer a:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .footer {
    height: 44px;
  }
  .footer p {
    font-size: 12px;
    line-height: 1.4;
  }
}
</style>
